import { zodResolver } from '@hookform/resolvers/zod';
import type { z } from 'zod';

/**
 * Thin wrapper around zodResolver for storefront forms.
 * Casts through `any` so Zod / @hookform/resolvers type surfaces stay compatible
 * across monorepo package versions (Standard Schema `~standard` skew).
 */
export function formResolver<TSchema extends z.ZodTypeAny>(schema: TSchema) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Zod/resolvers version skew in the monorepo
  return zodResolver(schema as any);
}
